var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.003,
    height: 28.004,
    viewBox: "0 0 28.003 28.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Question",
    d: "M943.3,19939.3a14,14,0,1,1,14,14A14.045,14.045,0,0,1,943.3,19939.3Zm2.334,0a11.668,11.668,0,1,0,11.668-11.668A11.706,11.706,0,0,0,945.629,19939.3Zm9.965,7.326a1.5,1.5,0,1,1,1.5,1.5A1.5,1.5,0,0,1,955.594,19946.623Zm.571-3.682v-.836a4.8,4.8,0,0,1,2.384-4.166,2.238,2.238,0,0,0,1.192-2.5,2.281,2.281,0,0,0-1.9-1.908,2.5,2.5,0,0,0-2.028.477,2.339,2.339,0,0,0-.831,1.787,1.192,1.192,0,0,1-2.384,0,4.879,4.879,0,0,1,1.668-3.689,4.662,4.662,0,0,1,3.931-1.072,4.821,4.821,0,0,1,3.811,3.811,4.713,4.713,0,0,1-2.384,5,2.29,2.29,0,0,0-1.072,2.145v.955a1.192,1.192,0,1,1-2.384,0Z",
    transform: "translate(-943.295 -19925.295)",
    fill: "#242424",
    opacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.7085d7a20fad893cc413fdaf3d4da01f.svg";
export { ForwardRef as ReactComponent };